export default "__VITE_ASSET__DeUc0bPU__"